import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";

export const getType = (type: CallConversation["type"]) => {
  switch (type) {
    case "inbound":
      return "INBOUND";
    case "outbound":
      return "OUTBOUND";
    default:
      return "VOICEMAIL";
  }
};
